/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import Loading from '../../components/atoms/Loading'
import { BadgeStatusCOA } from '../../components/atoms/StatusLabel'
import { Search } from 'lucide-react'
import {
  capitalizeFirstLetter,
  convertDateWithTime
} from '../../helpers/constants'
import api from '../../config/AxiosInstance'
import TablePagination from '../../components/atoms/Table/TablePagination'
import { Loader } from 'react-bootstrap-typeahead'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const valueStyle = {
  fontSize: '0.9rem',
  fontWeight: '500',
  color: '#212529',
  minHeight: '24px'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function ManualStockOpnameDetail() {
  const { state } = useLocation()
  const { id } = useParams()
  const [loadingTable, setLoadingTable] = useState(false)
  const navigate = useNavigate()
  const [data, setData] = useState({
    values: {
      id: null,
      code: null,
      status: null,
      checker: null,
      pic: null,
      created_by: null,
      created_at: null,
      updated_by: null,
      updated_at: null
    },
    metadata: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })
  const [filter, setFilter] = useState({
    q: ''
  })
  const [debouncedQ, setDebouncedQ] = useState('')
  const [loading, setLoading] = useState(false)
  const handleBack = () => {
    navigate('/stock-opname/cycle-count', {
      replace: true,
      state: {
        warehouse: state?.warehouse,
        status: state?.status || '',
        q: state?.q
      }
    })
  }
  const columns = [
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    { key: 'total_pack_system', label: 'Pack (System)' },
    {
      key: 'total_pack_checked',
      label: 'Last Checked',
      component: (value) => (
        <div key={value.id}>
          {value.total_pack_checked > 0 && (
            <span
              style={{
                color: `${
                  value.total_pack_checked > value.total_pack_system
                    ? '#333333'
                    : '#219653'
                }`
              }}
              className="fw-bold"
            >
              {value.total_pack_checked}
            </span>
          )}
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      component: (value) => {
        if (value?.status) {
          return <BadgeStatusCOA text={value?.status || 'match'} />
        }
        return ''
      }
    },
    {
      key: 'action',
      label: 'Action',
      component: (value) => (
        <div key={value?.id}>
          <Button
            variant="secondary"
            onClick={() => {
              navigate(
                `/stock-opname/manual-stock-opname/detail/${id}/${value?.id}`,
                {
                  replace: true,
                  state: state
                }
              )
            }}
          >
            <Search size={14} />
          </Button>
        </div>
      )
    }
  ]
  const handlePageChange = (data) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: data.selected + 1
      }
    }))
    window.scrollTo(0, 0)
  }

  const handleOnChangeMeta = (e) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: 1,
        per_page: parseInt(e.target.value, 10)
      }
    }))
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQ(filter.q)
      if (filter.q !== debouncedQ) {
        setData((prevData) => ({
          ...prevData,
          metadata: {
            ...prevData.metadata,
            current_page: 1
          }
        }))
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.q])

  const fetchData = async () => {
    try {
      setLoading(true)
      const params = {
        q: filter?.q || '',
        per_page: data?.metadata?.per_page || 10,
        page: data?.metadata?.current_page || 1
      }
      const res = await api.get(`/stock-opname/manual/${id}`, {
        params
      })
      const { data: dataResponse, metadata: metadataResponse } = res.data
      setData({
        values: dataResponse,
        metadata: metadataResponse
      })
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      handleBack()
    } finally {
      setLoading(false)
    }
  }
  const fetchItems = async () => {
    try {
      setLoadingTable(true)
      const params = {
        q: debouncedQ || '',
        per_page: data?.metadata?.per_page || 10,
        page: data?.metadata?.current_page || 1
      }
      const res = await api.get(`/stock-opname/manual/${id}`, {
        params
      })
      const { data: dataResponse, metadata: metadataResponse } = res.data
      setData((prevData) => ({
        ...prevData,
        metadata: metadataResponse,
        values: {
          ...prevData.values,
          items: dataResponse?.items
        }
      }))
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setTimeout(() => {
        setLoadingTable(false)
      }, 500)
    }
  }
  useEffect(() => {
    fetchData()
  }, [id])
  useEffect(() => {
    if (data?.values?.id) {
      fetchItems()
    }
  }, [data?.metadata?.per_page, data?.metadata?.current_page, debouncedQ])
  if (loading) {
    return <Loading />
  }

  const renderInfoItem = (label, value, col = 3) => (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelStyle}>{label}</Form.Label>
      <div className="px-0" style={valueStyle}>
        {value || '-'}
      </div>
    </Form.Group>
  )

  return (
    <>
      <Toaster />
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col
            md={12}
            className="d-flex justify-content-between align-items-start"
          >
            <div className="d-flex flex-column justify-content-start">
              <h4
                style={headerTitleStyle}
                className="d-flex align-items-center gap-2"
              >
                {data?.values?.code || ''}{' '}
                <sup style={{ fontSize: '12px', marginLeft: '5px' }}>
                  <BadgeStatusCOA text={data?.values?.status || 'finished'} />
                </sup>
              </h4>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-6">
                  <li className="breadcrumb-item">
                    <Link
                      to="/stock-opname/manual-stock-opname"
                      className="text-decoration-none"
                    >
                      <span className="text-black fw-bold text-uppercase">
                        MANUAL STOCK OPNAME
                      </span>
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item sj-item active"
                    aria-current="page"
                  >
                    {data?.values?.code || ''}
                  </li>
                </ol>
              </nav>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('WAREHOUSE', state?.warehouse_name)}
            {renderInfoItem('CHECKER', data?.values?.checker)}
            {renderInfoItem('PIC', data?.values?.pic)}
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            <Col md={12}>
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center justify-content-center">
                  <h5 className="text-muted fw-bold">ITEM</h5>
                </div>
                <div
                  className="d-flex justify-content-end"
                  style={{ width: '30%' }}
                >
                  <InputGroup className="mb-3">
                    <InputGroup.Text
                      style={{
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #e9ecef',
                        borderRight: 'none',
                        borderTopLeftRadius: '10px',
                        borderBottomLeftRadius: '10px'
                      }}
                    >
                      <Search size={16} className="text-muted" />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      aria-label="Search"
                      placeholder="Search"
                      name="q"
                      value={filter.q}
                      onChange={(e) =>
                        setFilter({ ...filter, q: e.target.value })
                      }
                      style={{
                        ...FormControlStyle,
                        borderLeft: 'none',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                      }}
                    />
                  </InputGroup>
                </div>
              </div>
            </Col>
            <Col md={12}>
              <Table
                hover
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    {columns.map((column) => (
                      <th
                        className={`align-middle p-2 ${column.className ?? ''}`}
                        key={column.key}
                        style={tableHeaderStyle}
                      >
                        <span>{column.label}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loadingTable && (
                    <tr key={`loading-${Math.random()}`}>
                      <td colSpan={columns.length} className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  )}
                  {!loadingTable && !data?.values?.items?.length && (
                    <tr key={`not-found-${Math.random()}`}>
                      <td colSpan={columns.length} className="text-center">
                        Data not found
                      </td>
                    </tr>
                  )}
                  {!loadingTable &&
                    data?.values?.items?.length > 0 &&
                    data?.values?.items?.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        {columns.map((column) => (
                          <td
                            key={column.key}
                            className={`align-middle p-2 ${
                              column.className ?? ''
                            }`}
                          >
                            {column.component && column.component(item)}
                            {!column.component && item[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td className="p-3" colSpan={columns.length}>
                      <TablePagination
                        meta={data.metadata}
                        handlePageChange={handlePageChange}
                        handleOnChangeMeta={handleOnChangeMeta}
                      />
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </Col>
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem(
              'created by',
              data?.values?.created_by
                ? capitalizeFirstLetter(data?.values?.created_by)
                : '-'
            )}
            {renderInfoItem(
              'created at',
              data?.values?.created_at && data?.created_at !== '-'
                ? convertDateWithTime(
                    data?.values?.created_at,
                    'DD-MM-YYYY, HH:mm'
                  )
                : '-'
            )}
            {renderInfoItem(
              'last updated by',
              data?.values?.updated_by
                ? capitalizeFirstLetter(data?.values?.updated_by)
                : '-'
            )}
            {renderInfoItem(
              'last updated at',
              data?.values?.updated_at
                ? convertDateWithTime(
                    data?.values?.updated_at,
                    'DD-MM-YYYY, HH:mm'
                  )
                : '-'
            )}
          </Row>
        </Card>
      </Container>
    </>
  )
}
export default ManualStockOpnameDetail
